module.exports = __webpack_public_path__ + "img/burger.602db97a.svg";